import { useObserver } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';

import { useStores } from '../../stores';
import { handleError } from '../../utilities';
import ErrorBoundary from '../ErrorBoundary';

const ErrorHandler = ({ children }) => {
  const { app } = useStores();

  return useObserver(() => (
    <ErrorBoundary
      onCatch={error => {
        app.log({
          Message: handleError(error)
        });
      }}
    >
      {children}
    </ErrorBoundary>
  ));
};

ErrorHandler.propTypes = {
  children: PropTypes.node.isRequired
};

export default ErrorHandler;
